import colors from "admin/assets/theme/base/colors";
import boxShadow from "admin/assets/theme/functions/boxShadow";

const { black, white, tabs } = colors;

const boxShadows = {
  xs: "none",
  sm: "none",
  md: "none",
  lg: "none",
  xl: "none",
  xxl: "none",
  inset: "none",
  colored: {
    primary: "none",
    secondary: "none",
    info: "none",
    success: "none",
    warning: "none",
    error: "none",
    light: "none",
    dark: "none",
  },
  navbarBoxShadow: "none",
  sliderBoxShadow: {
    thumb: "none",
  },
  tabsBoxShadow: {
    indicator: boxShadow([0, 1], [5, 1], tabs.indicator.boxShadow, 1),
  },
};

export default boxShadows;
